import { Flex } from '@pancakeswap/uikit'
import { ReactNode, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import Header from './Header'
import SearchModal from './Header/components/Search/SearchModal'
import Sidebar from './Sidebar'
import { Body, Main } from './styled'

const Wrapper = styled(Flex)`
  display: flex;
  flex: 1 0 0;
  align-items: flex-start;
  flex-shrink: 0;
  height: auto;
  position: relative;
`

interface LayoutProps {
  children: ReactNode
}

export default function Layout({ children }: LayoutProps) {
  const mainRef = useRef<HTMLDivElement | null>(null)
  const asideRef = useRef<HTMLDivElement | null>(null)
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false)

  useEffect(() => {
    const mainElement = mainRef.current
    const asideElement = asideRef.current

    const syncScroll = () => {
      if (mainElement && asideElement) {
        asideElement.scrollTop = mainElement.scrollTop
      }
    }

    if (mainElement) {
      mainElement.addEventListener('scroll', syncScroll)
    }

    return () => {
      if (mainElement) {
        mainElement.removeEventListener('scroll', syncScroll)
      }
    }
  }, [])

  return (
    <Wrapper>
      <Sidebar ref={asideRef} />
      <Main ref={mainRef}>
        {/* {loading ? (
          <SpinnerWrapper>
            <Spinner />
          </SpinnerWrapper>
        ) : ( */}
        <Header onClickSearchBtn={() => setIsModalVisible(true)} />
        <Body>{children}</Body>
      </Main>
      {isModalVisible && <SearchModal onClose={() => setIsModalVisible(false)} onChangeSearchInput={() => {}} />}
    </Wrapper>
  )
}
